export const tabsAll = [
  {
    text: 'Показания (рассчитанные)',
    content: 'RegReads'
  },
  {
    text: 'Показания (переданные)',
    content: 'RegReadsLkk'
  },
  {
    text: 'Профиль (рассчитанный)',
    content: 'OutVals'
  },
  {
    text: 'Профиль (переданный)',
    content: 'OutValsLkk'
  }
]

export const tabsRenergy = [
  {
    text: 'Принятые к расчету показания',
    content: 'RegReads'
  },
  {
    text: 'Показания, переданные через ЛК',
    content: 'RegReadsLkk'
  },
  {
    text: 'Принятый к расчету профиль',
    content: 'OutVals'
  },
  {
    text: 'Переданный через ЛК профиль',
    content: 'OutValsLkk'
  }
]

